import styled from 'styled-components';
import { colors } from 'nicollet-tokens';

const OptionLabel = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 5;
  ${({
  hasStrikethrough
}) => hasStrikethrough ? `
    text-decoration: line-through;
  ` : ''};
  ${({
  disabled
}) => disabled ? `
    color: ${colors.palette.gray.medium};
  ` : `

      color:${colors.text.onLight.primary}`};
`;

export { OptionLabel };
